export default __webpack_public_path__ + "static/media/ic_cocos_island.714267e1.svg";